<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <button v-if="['admin'].includes(userRole)" class="dropdown-btn"><span class="text-btn">DASHBOARD</span><i class="fa fa-caret-right"></i></button>
        <div class="dropdown-container" data-routes="dashboard-pontos">
          <sidebar-link to="/dashboard-pontos" name="Pontos"/>
        </div>

        <button v-if="['admin'].includes(userRole)" class="dropdown-btn mt-3">
          <span class="text-btn">CAMPANHAS LIGAÇÕES</span>
          <i class="fa fa-caret-right"></i>
        </button>
        <div
          class="dropdown-container"
          data-routes="cobranca-aviso,cobranca-bloqueado,cobranca-generica"
        >
          <sidebar-link to="/cobranca-aviso" name="Aviso e Reaviso" />
          <sidebar-link to="/cobranca-bloqueado" name="Bloqueado" />
          <sidebar-link to="/cobranca-cancelado" name="Cancelado" />
          <sidebar-link to="/cobranca-generica" name="Generica" />
        </div>

        <button v-if="['admin'].includes(userRole) && domain === 'dash.globalfibra.com.br'" class="dropdown-btn mt-3"><span class="text-btn">CAMPANHAS SMS</span><i class="fa fa-caret-right"></i></button>
        <div class="dropdown-container" data-routes="envio-sms">
          <sidebar-link to="/envio-sms" name="Envio de SMS" />
        </div>

        <button v-if="['admin', 'operator', 'supervisor'].includes(userRole)" class="dropdown-btn mt-3">
          <span class="text-btn">CONTRATOS</span>
          <i class="fa fa-caret-right"></i>
        </button>
        <div class="dropdown-container" data-routes="contratos-falhos,contratos,contratos-criar">
          <sidebar-link to="/contratos-criar" name="Gerador de Contratos" />
          <sidebar-link to="/contratos" name="Lista de Contratos" />
          <sidebar-link to="/contratos-falhos" name="Contratos Falhos" />
        </div>

        <button v-if="['admin'].includes(userRole)" class="dropdown-btn mt-3">
          <span class="text-btn">PLANOS</span>
          <i class="fa fa-caret-right"></i>
        </button>
        <div class="dropdown-container" data-routes="planos,tv,telefones,personalizados,combos">
          <sidebar-link to="/planos" name="Mostruario de Planos" />
          <sidebar-link to="/combos" name="Lista de Combos" />
        </div>

        <button v-if="['admin', 'operator', 'supervisor', 'salesperson'].includes(userRole)" class="dropdown-btn mt-3">
          <span class="text-btn">LEADS</span>
          <i class="fa fa-caret-right"></i>
        </button>
        <div class="dropdown-container" data-routes="leads">
          <sidebar-link to="/leads" name="Lista de Leads" />
        </div>

        <button v-if="['admin','operator', 'supervisor'].includes(userRole)" class="dropdown-btn mt-3"><span class="text-btn">CLIENTES</span><i class="fa fa-caret-right"></i></button>
        <div class="dropdown-container" data-routes="clientes">
          <sidebar-link to="/clientes" name="Lista de Clientes"/>
        </div>

        <button v-if="['admin', 'logistics'].includes(userRole) && domain === 'dash.globalfibra.com.br'" class="dropdown-btn mt-3"><span class="text-btn">MOVIMENTAÇÃO CARROS</span><i class="fa fa-caret-right"></i></button>
        <div class="dropdown-container" data-routes="movimentacao-carros,carros-cadastrados,motoristas-cadastrados">
          <sidebar-link to="/movimentacao-carros" name="Movimentação de Carros"/>
          <sidebar-link to="/carros-cadastrados" name="Carros Cadastrados"/>
          <sidebar-link to="/motoristas-cadastrados" name="Motoristas Cadastrados"/>
        </div>

        <button v-if="['admin','supervisor'].includes(userRole)" class="dropdown-btn mt-3"><span class="text-btn">OUVIDORIA</span><i class="fa fa-caret-right"></i></button>
        <div class="dropdown-container" data-routes="atendimentos">
          <sidebar-link to="/atendimentos" name="Atendimentos"/>
        </div>
        <span class="version">v{{ versionNumber }}</span>
      </template>
      <mobile-menu>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="toggleSidebar"></dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
.active .fa-caret-right {
  transform: rotate(90deg);
}
.text-btn {
  margin-left: 15px;
}
.dropdown-btn {
  font-family: "Muli", "Helvetica", Arial, sans-serif;
  text-decoration: none;
  font-size: 13px;
  letter-spacing: 0.1em;
  color: #f4f3ef;
  display: flex;
  justify-content: space-between;
  border: none;
  border-bottom: 1px solid #3a3838;
  background: #212120;
  width: 99%;
  padding: 10px 0;
  text-align: left;
  cursor: pointer;
  outline: none;
}
.dropdown-btn:hover {
  color: #f1f1f1;
}
.dropdown-container {
  display: none;
  background-color: #262626;
  padding-left: 8px;
  width: 99%;
}
.nav {
  display: flex;
  justify-content: center;
  align-items: center;
}
.version {
  position: absolute;
  bottom: 0;
}
</style>
<script>
import { version } from "../../../package.json";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  computed: {
    versionNumber() {
      return version;
    },
    userRole() {
      return this.$store.getters.user.role;
    },
    domain() {
      return window.location.hostname;
    }
  },
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  mounted() {
    const dropdown = document.getElementsByClassName("dropdown-btn");
    for (let i = 0; i < dropdown.length; i++) {
      const dropdownContent = dropdown[i].nextElementSibling;
      const routes = dropdownContent.dataset.routes.split(",");
      const route = this.$route.name;

      if (routes.includes(route)) {
        dropdown[i].classList.toggle("active");
        dropdownContent.style.display = "block";
      }

      dropdown[i].addEventListener("click", function() {
        const dropdownContainers = document.getElementsByClassName(
          "dropdown-container"
        );
        for (let j = 0; j < dropdownContainers.length; j++) {
          if (dropdownContainers[j] === dropdownContent) {
            continue;
          }
          dropdownContainers[j].style.display = "none";
        }

        const dropdownButtons = document.getElementsByClassName("dropdown-btn");
        for (let j = 0; j < dropdownButtons.length; j++) {
          if (dropdownButtons[j] === this) {
            continue;
          }
          dropdownButtons[j].classList.remove("active");
        }

        this.classList.toggle("active");

        if (dropdownContent.style.display === "block") {
          dropdownContent.style.display = "none";
        } else {
          dropdownContent.style.display = "block";
        }
      });
    }
  }
};
</script>
